

















import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import {blue, red} from "@/utils/colors";
import { BarChart } from 'vue-morris';
import {Dashboard} from "@/services/BackendProxies";
import * as _ from 'lodash';

@Component({components: {BarChart}})
export default class TroskoviVozila extends Vue {
    @Prop() dashboard!: Dashboard;

    data = {
        labels: [],
        datasets: []
    };
    godina = 0;
    godine = [];

    @Watch('dashboard')
    onDashboardChanged(dashboard: Dashboard) {
        this.godine = _.keys(dashboard.troskoviOdrzavanjaPoVozilima).sort((a, b) => -a.localeCompare(b));
        if (this.godine.length) {
            this.godina = this.godine[0];
        }
    }

    @Watch('godina')
    onGodinaChanged(godina: number) {
        const troskoviPoVozilima = this.dashboard.troskoviOdrzavanjaPoVozilima[godina];
        const vozila = [];
        const iznosi = [];
        troskoviPoVozilima.forEach(x => {
            vozila.push(x.vozilo);
            iznosi.push(x.iznos);
        });
        this.data = {labels: vozila, datasets: [{backgroundColor: blue, data: iznosi}]};
    }
}
